module.exports = __webpack_public_path__ + "img/t1.9f7fd813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/t1.png
// module id = Ps4j
// module chunks = 1